import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M6.142 6.588c-.486-.739-.476-1.441-.21-1.929.264-.483.864-.909 1.881-.909.835 0 1.665.397 2.327.95.325.273.59.568.778.837.197.284.271.487.285.576a.75.75 0 0 0 .77.637.75.75 0 0 0 .768-.637c.014-.09.088-.292.285-.576.188-.27.453-.564.779-.837.661-.553 1.491-.95 2.326-.95 1.017 0 1.617.426 1.88.909.267.488.278 1.19-.208 1.929a.75.75 0 0 0 1.253.824c.743-1.13.843-2.426.272-3.472-.573-1.05-1.736-1.69-3.197-1.69-1.296 0-2.455.603-3.288 1.3-.335.28-.63.584-.87.891a6.057 6.057 0 0 0-.871-.891c-.833-.697-1.993-1.3-3.289-1.3-1.46 0-2.623.64-3.197 1.69-.57 1.046-.47 2.343.273 3.472a.75.75 0 0 0 1.253-.824Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M1.25 8c0-.966.784-1.75 1.75-1.75h18c.966 0 1.75.784 1.75 1.75v2A1.75 1.75 0 0 1 21 11.75h-.25V21A1.75 1.75 0 0 1 19 22.75H5A1.75 1.75 0 0 1 3.25 21v-9.25H3A1.75 1.75 0 0 1 1.25 10V8Zm11.5 3.75v9.5H19a.25.25 0 0 0 .25-.25v-9.25h-6.5Zm0-1.5H21a.25.25 0 0 0 .25-.25V8a.25.25 0 0 0-.25-.25h-8.25v2.5Zm-1.5-2.5H3a.25.25 0 0 0-.25.25v2c0 .138.112.25.25.25h8.25v-2.5Zm0 4h-6.5V21c0 .138.112.25.25.25h6.25v-9.5Z"
    />
  </svg>
);
export default SvgTwoColorGift;
